module.exports = __webpack_public_path__ + "img/ico-check.742a99a6.svg";